// extracted by mini-css-extract-plugin
export default {"pageWrap":"Re-z","fullWidth":"Se-z","heading":"Te-z","fullBleed":"Ue-z","hidden":"Ve-z"};